const initialState =
 {  
    code:0,
    message:""
 }

export default (state = initialState, action) => {
    switch (action.type) {
        case "ERROR_TOKEN_MAIN":
            return { ...state,message:action.payload.message,code:action.payload.code};
        default:
    }
    return state;
}
